import { createActionHelpers } from 'vuex-loading';
import fileDownload from 'js-file-download';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    attendant: {
        outlet: {
            details: {},
            preference: {},
        },
        summary: {
            fuel_sales: [],
            payments: [],
        },
        cash_adjustments: [],
    },
    staffList: [],
    outletId: null,
};

const getters = {
    attendant: state => state.attendant,

    fuelSales(getters) {
        if (getters.attendant.summary) {
            const fuelSalesArray = getters.attendant.summary.fuel_sales;

            if (fuelSalesArray) {
                return fuelSalesArray.slice().sort((a, b) => a.id - b.id);
            }
        }

        return null;
    },

    totalFuelSales(getters) {
        if (getters.attendant.summary) {
            return getters.attendant.summary.fuel_sales
                .map(sale => {
                    return parseFloat(sale.amount);
                })
                .reduce((a, c) => a + c, 0);
        }

        return 0;
    },

    payments(getters) {
        if (getters.attendant.summary) {
            return getters.attendant.summary.payments;
        }

        return null;
    },

    totalPayments(getters) {
        if (getters.attendant.summary) {
            return getters.attendant.summary.payments
                .map(sale => {
                    return parseFloat(sale.amount);
                })
                .reduce((a, c) => a + c, 0);
        }

        return 0;
    },

    startFloat(getters) {
        return getters.attendant.opening_amount;
    },

    endFloat(getters) {
        return getters.attendant.closing_amount;
    },

    shortExtra(getters) {
        if (getters.attendant.summary) {
            return getters.attendant.summary.short_extra;
        }

        return 0;
    },

    safeDropCount(getters) {
        return getters.attendant.cash_adjustments.length;
    },

    safeDropTotal(getters) {
        return getters.attendant.cash_adjustments
            .map(cashAdjustment => {
                return parseFloat(cashAdjustment.amount);
            })
            .reduce((a, c) => a + c, 0);
    },

    panNumber(getters) {
        if (getters.attendant.pan_number) {
            return getters.attendant.pan_number.replace(/\d(?=\d{4})/g, '.');
        }

        return null;
    },

    rounding(getters) {
        if (getters.attendant.summary) {
            return getters.attendant.summary.rounding;
        }

        return 0;
    },
};

const mutations = {
    setAttendant(state, data) {
        state.attendant = data;
    },

    setStaffList(state, data) {
        state.staffList = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setOutletId(state, data) {
        state.outletId = data;
    },
};

const actions = {
    async getAttendant({ commit, dispatch }, id) {
        const url = Laroute.route('franchise.report.attendant.session.show', {
            id,
        });

        startLoading(dispatch, 'show-attendant');

        try {
            const { data } = await axios.get(url);
            commit('setAttendant', data);
            endLoading(dispatch, 'show-attendant');

            return data;
        } catch (e) {
            endLoading(dispatch, 'show-attendant');
            throw e;
        }
    },

    async print({ dispatch, getters }) {
        let data = {
            id: getters.attendant.id,
            attendant: getters.attendant,
            fuelSales: getters.fuelSales,
            totalFuelSales: getters.totalFuelSales,
            payments: getters.payments,
            totalPayments: getters.totalPayments,
            startFloat: getters.startFloat,
            endFloat: getters.endFloat,
            shortExtra: getters.shortExtra,
            safeDropCount: getters.safeDropCount,
            safeDropTotal: getters.safeDropTotal,
            panNumber: getters.panNumber,
            rounding: getters.rounding,
        };

        startLoading(dispatch, 'print');

        await axios({
            url: Laroute.route('franchise.report.attendant.session.print'),
            responseType: 'blob',
            method: 'post',
            headers: { Accept: 'multipart/form-data' },
            data,
        })
            .then(response => {
                endLoading(dispatch, 'print');
                fileDownload(response.data, 'Till Attendant.pdf');
            })
            .catch(error => {
                endLoading(dispatch, 'print');
                throw error;
            });
    },

    async getAttendantStaff({ commit, dispatch }, params) {
        const url = Laroute.route(
            'franchise.report.attendant.session.attendant.staff',
        );

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'get-attendant-staff');

        try {
            const { data } = await axios.get(url, options);
            commit('setAttendant', data);
            endLoading(dispatch, 'get-attendant-staff');

            return data;
        } catch (e) {
            endLoading(dispatch, 'get-attendant-staff');
            throw e;
        }
    },

    getAttendantStaffIfNecessary({ commit, dispatch }, params = {}) {
        if (
            params.outlet_id != state.outletId ||
            !state.staffList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);

            return dispatch('getAttendantStaff', params);
        }

        return Promise.resolve(state.staffList);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
